export default __webpack_public_path__ + "static/media/p7.8a940c00.png";